import React, { } from "react";
import BrandComponents from "../Brand/BrandComponents";
function WarehouseTable () {

  let header = [
    { label: "Id", field: "id" },
    { label: "Warehouse Name", field: "warehousename" },
    { label: "Address", field: "address" },
    { label: "Warehouse Type.", field: "warehousetype" },
  ];

  return (
    <div>
    <BrandComponents
    header={header}
    tableTitle={"WAREHOUSE"}
    apiField={"warehouse"}
    addButton={"+ ADD"}
    createRoute={"/warehouseCreate"}
    updateRoute={"/warehouseView"}
    viewRoute = {"/warehouseView"}
    />
    </div>
  );
}

export default WarehouseTable;
